"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../amplify/constants");
function mapErrorToResponse(error, response) {
    response.status = "failed";
    response.code = "UNKNOWN_ERROR";
    // console.log("mapErrorToResponse");
    // console.log("incoming error")
    // console.log(JSON.stringify(error));
    if (error) {
        var isErrorExtracted = false;
        if (error.message) {
            var errorObject = createObjectFromString(error.message);
            // console.log("errorObject created from message");
            // console.log(errorObject);
            if (errorObject && errorObject.code) {
                response.code = errorObject.code || "UNKNOWN_ERROR";
                response.message = errorObject.message || "";
                response.supportCode = errorObject.supportCode || "";
                isErrorExtracted = true;
                if (errorObject.details) {
                    for (var _i = 0, _a = errorObject.details; _i < _a.length; _i++) {
                        var detail = _a[_i];
                        response.details.push({
                            code: detail.code,
                            message: detail.message,
                            field: detail.field
                        });
                    }
                }
            }
        }
        if (!isErrorExtracted) {
            if (constants_1.KNOWN_COGNITO_CODES.includes(error.code)) {
                response.code = error.code;
                response.message = error.message || "";
            }
            else if (error === constants_1.AUTH_NOT_AUTHENTICATED) {
                // This is to trap where Auth.currentAuthenticatedUser() returns "not authenticated" instead
                // of a full error object.
                response.code = constants_1.RESPONSE_CODES.SignIn_UserNotAuthorised;
                response.message = error;
            }
        }
    }
    // console.log("response object");
    // console.log(response);
}
exports.mapErrorToResponse = mapErrorToResponse;
function createObjectFromString(message) {
    var _a = findBracePositions(message), startPosition = _a[0], endPosition = _a[1];
    if (startPosition >= 0 && startPosition < endPosition) {
        var subString = getSubStringFromMessage(message, startPosition, endPosition);
        return JSON.parse(subString);
    }
}
exports.createObjectFromString = createObjectFromString;
function findBracePositions(message) {
    var openingBraceLocation = message.indexOf("{");
    var closingBraceLocation = message.lastIndexOf("}");
    return [openingBraceLocation, closingBraceLocation];
}
exports.findBracePositions = findBracePositions;
function getSubStringFromMessage(message, startPosition, endPosition) {
    // end position needs to be plus one on where charater located.
    var subString = message.substring(startPosition, endPosition + 1);
    return subString;
}
exports.getSubStringFromMessage = getSubStringFromMessage;
